import React, { useState, useEffect, useCallback } from "react";
import { Navigate } from "react-router-dom";
import ZoomLoading from "components/commons/ZoomLoading";

const Meeting = (props) => {
  // Navigation state is only present when the user entered from an in-app Join
  // click. On a browser refresh it is gone (the /live/ Zoom app rewrites the
  // address bar to /…/meeting, so the reload boots a fresh page with no state),
  // so read it defensively and redirect below instead of crashing.
  const {
    sessionId,
    teacherId,
    sessionType,
    activeSessionName,
    sessionName,
    listName,
    listPosition,
    zoomMtgNumber,
    zoomMtgPassWord,
    zoomMtgSignature,
  } = props.location?.state ?? {};

  const [isZoomVideoCall, setisZoomVideoCall] = useState(false);

  const [leaveUrl, setLeaveUrl] = useState(
    `/user/sessions/${
      activeSessionName?.toLowerCase() === "company" ||
      activeSessionName?.toLowerCase() === "community"
        ? "group"
        : activeSessionName
    }/${sessionId}/meeting/feedback?sessionId=${sessionId}&teacherId=${teacherId}&sessionType=${sessionType}&sessionTitle=${sessionName}`
  );

  const replaceUrl = `/user/sessions/${
    activeSessionName?.toLowerCase() === "company" ||
    activeSessionName?.toLowerCase() === "community"
      ? "group"
      : activeSessionName
  }/${sessionId}/meeting`;

  const replaceTitle = `Meeting - ${sessionName} - Sessions - Walking on Earth`;

  const handleVideoCall = useCallback(() => {
    setLeaveUrl((prevLeaveUrl) => `${prevLeaveUrl}`);
    setisZoomVideoCall(true);
  }, []);

  useEffect(() => {
    handleVideoCall();
  }, [handleVideoCall]);

  useEffect(() => {
    if (isZoomVideoCall && zoomMtgNumber) {
      const liveUrl = new URL("/live/", window.location.origin);
      liveUrl.searchParams.append("meetingNumber", zoomMtgNumber);
      liveUrl.searchParams.append("signature", zoomMtgSignature);
      liveUrl.searchParams.append("passWord", zoomMtgPassWord);
      liveUrl.searchParams.append("leaveUrl", leaveUrl);
      liveUrl.searchParams.append("replaceUrl", replaceUrl);
      liveUrl.searchParams.append("replaceTitle", replaceTitle);
      liveUrl.searchParams.append("sessionType", sessionType);
      liveUrl.searchParams.append("sessionId", sessionId);
      liveUrl.searchParams.append("sessionName", sessionName);
      liveUrl.searchParams.append("listName", listName);
      liveUrl.searchParams.append("listPosition", listPosition);

      window.location.href = liveUrl.href;
    }
  }, [
    isZoomVideoCall,
    leaveUrl,
    replaceUrl,
    replaceTitle,
    sessionId,
    sessionType,
    sessionName,
    listName,
    listPosition,
    zoomMtgNumber,
    zoomMtgPassWord,
    zoomMtgSignature,
  ]);

  // Refresh / deep link with no session data: the Zoom session is gone, so send
  // the user back to the session (where Join lives) instead of a blank spinner.
  // Dropping "/meeting" hits the deprecated-session redirect, which lands the
  // user on the session in Discover.
  if (!zoomMtgNumber) {
    return (
      <Navigate
        to={props.location?.pathname?.replace("/meeting", "") ?? "/user/home"}
        replace
      />
    );
  }

  return <ZoomLoading />;
};

export default Meeting;
